export default function Download() {
  return (
    <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.88889 8.77778V1M4.88889 8.77778L1.55556 5.44444M4.88889 8.77778L8.22222 5.44444M8.77778 11H1"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
